import { render, staticRenderFns } from "./ResendConfirmCodePage.vue?vue&type=template&id=cc3e0eb2&scoped=true&"
import script from "./ResendConfirmCodePage.vue?vue&type=script&lang=ts&"
export * from "./ResendConfirmCodePage.vue?vue&type=script&lang=ts&"
import style0 from "./ResendConfirmCodePage.vue?vue&type=style&index=0&id=cc3e0eb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc3e0eb2",
  null
  
)

export default component.exports